export const START_DAY_FLUSH_WAIT_MS = 300;

export const createStartDayFlusher = ({
  waitMs = START_DAY_FLUSH_WAIT_MS,
  getFlushed,
  setFlushed,
  commit,
}) => {
  let timer = null;
  let pending = getFlushed();

  const flush = (date) => {
    if (date === getFlushed()) return;
    setFlushed(date);
    commit(date);
  };

  return {
    schedule(nextDay) {
      pending = nextDay;
      if (timer) {
        clearTimeout(timer);
      } else {
        flush(nextDay);
      }
      timer = setTimeout(() => {
        timer = null;
        flush(pending);
      }, waitMs);
    },
    hasPendingTimer() {
      return timer != null;
    },
    dispose() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    },
  };
};

/**
 * Debounce azioni (es. refresh): primo click subito,
 * in raffica riprogramma e a fine wait esegue solo l’ultimo.
 */
export const createLeadingTrailingActionFlusher = ({
  waitMs = START_DAY_FLUSH_WAIT_MS,
} = {}) => {
  let timer = null;
  let trailingPending = false;

  return {
    schedule(run) {
      if (!timer) {
        run();
        trailingPending = false;
        timer = setTimeout(() => {
          timer = null;
          if (trailingPending) {
            trailingPending = false;
            run();
          }
        }, waitMs);
        return;
      }

      trailingPending = true;
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        if (trailingPending) {
          trailingPending = false;
          run();
        }
      }, waitMs);
    },
    dispose() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      trailingPending = false;
    },
  };
};
